/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  // PROD
  auth: {
    clientId: '41e9ee92-ac53-42e2-bddb-c053dc2d90b9',
    authority: 'https://login.microsoftonline.com/cd99fef8-1cd3-4a2a-9bdf-15531181d65e/',
    redirectUri: 'https://wcoxml.dhl.com',
    postLogoutRedirectUri: 'https://wcoxml.dhl.com',
  },

  // DEV
  // auth: {
  //   clientId: '3cd8675a-b730-447d-8b4a-51d5b02c4422',
  //   authority: 'https://login.microsoftonline.com/cd99fef8-1cd3-4a2a-9bdf-15531181d65e/',
  //   // redirectUri: 'https://wcoxlm-demo1.azurewebsites.net',
  //   // postLogoutRedirectUri: 'https://wcoxlm-demo1.azurewebsites.net',
  //   redirectUri: 'https://0088036wcoxmlstdev-webapp-pldnsazr.azurewebsites.net',
  //   postLogoutRedirectUri: 'https://0088036wcoxmlstdev-webapp-pldnsazr.azurewebsites.net',
  // },

  // PRIVATE DEV
  // auth: {
  //   clientId: '3cd8675a-b730-447d-8b4a-51d5b02c4422',
  //   authority: 'https://login.microsoftonline.com/cd99fef8-1cd3-4a2a-9bdf-15531181d65e/',
  //   redirectUri: 'https://wcoxlm-demo1.azurewebsites.net',
  //   postLogoutRedirectUri: 'https://wcoxlm-demo1.azurewebsites.net',
  // },

  // LOCAL
  // auth: {
  //   clientId: 'd69ba4f3-d8c5-487d-b431-4f98bc03ed91',
  //   authority: 'https://login.microsoftonline.com/821cdcf7-2fc9-45a7-8aa1-e319d000c469/',
  //   redirectUri: 'http://localhost:3000',
  //   postLogoutRedirectUri: 'http://localhost:3000',
  // },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read'],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'Enter_the_Graph_Endpoint_Herev1.0/me',
};
